import React from 'react';
import { string, element, shape, objectOf, any, node } from 'prop-types';
import { Link } from 'react-router';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import cx from 'classnames';
import { get, omit } from 'lodash';

import { Container } from 'shared-components/grid';
import styles from './styles/index.scss';

const OverviewNullState = ({
  src,
  imageSize = '175px',
  title,
  description,
  descriptionLink,
  buttonText,
  to,
  heading,
  componentProps = {}
}) => {
  return (
    <Container topBarOffset sideBarOffset {...componentProps.container}>
      {heading &&
        <div>
          {heading}
        </div>}
      <div className={styles.content}>
        {src &&
          <div className={styles.image}>
            <img src={src} style={{ width: imageSize }} />
          </div>}
        <Typography
          classes={{
            title: cx(styles.title, get(componentProps.title, 'className'))
          }}
          variant="h2"
          component="h2"
          align="center"
          {...omit(componentProps.title, 'className')}
        >
          {title}
        </Typography>
        <Typography
          className={styles.description}
          variant="body1"
          component="div"
          align="center"
        >
          {description}
          {descriptionLink}
        </Typography>
        {buttonText &&
          <Button
            className={styles.button}
            component={Link}
            variant="contained"
            color="primary"
            to={to}
            {...componentProps.button}
          >
            {buttonText}
          </Button>}
      </div>
    </Container>
  );
};

OverviewNullState.propTypes = {
  src: string,
  imageSize: string,
  title: string.isRequired,
  description: node.isRequired,
  descriptionLink: element.isRequired,
  buttonText: string,
  to: string,
  heading: node,
  componentProps: shape({
    container: objectOf(any),
    title: objectOf(any),
    button: objectOf(any)
  })
};

export default OverviewNullState;



// WEBPACK FOOTER //
// ./src/client/shared-components/OverviewNullState/index.js